import { toast } from "@devhop/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { competitionKeys } from "@/modules/competition/presentation/api/queries";
import { scoresApi } from "./client";

export const scoresKeys = {
  judge: (eventId: string, n: 1 | 2 | 3, roundIndex: number) =>
    ["scores", eventId, `judge${n}`, roundIndex] as const,
};

export function useJudgeScoresQuery(
  eventId: string | undefined,
  judgeNumber: 1 | 2 | 3,
  roundIndex = 1,
) {
  return useQuery({
    queryKey: scoresKeys.judge(eventId ?? "", judgeNumber, roundIndex),
    queryFn: () => {
      if (!eventId) throw new Error("Missing event id");
      return scoresApi.listScores(eventId, judgeNumber, roundIndex);
    },
    enabled: Boolean(eventId) && roundIndex >= 1,
  });
}

export function useSaveScore(
  eventId: string | undefined,
  judgeNumber: 1 | 2 | 3,
  roundIndex = 1,
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      teamId,
      data,
    }: {
      teamId: string;
      data: Record<string, number | Record<string, number>>;
    }) => {
      if (!eventId) throw new Error("Missing event id");
      return scoresApi.saveScore(
        eventId,
        judgeNumber,
        teamId,
        data,
        roundIndex,
      );
    },
    onSuccess: () => {
      toast.success("ບັນທຶກຄະແນນແລ້ວ");
      if (eventId) {
        qc.invalidateQueries({
          queryKey: scoresKeys.judge(eventId, judgeNumber, roundIndex),
        });
        qc.invalidateQueries({
          queryKey: competitionKeys.results(eventId),
        });
      }
    },
    onError: () => toast.error("ບໍ່ສາມາດບັນທຶກໄດ້, ກາລຸນາລອງໃໝ່"),
  });
}
